import React from 'react'
import './App.css';
// import {BrowserRouter as Router, Routes, Route} from "react-router-dom"
// import { AuthProvider } from './config/Auth'



import {BrowserRouter as Router, Routes, Route} from "react-router-dom"
// import Register from './components/Register/Register';
// import Login from './components/Register/Login'
import Main from './components/Main';

function App() {    
  return (
    <div className="App">
      <Main/>
    </div>
    
  );
}

export default App;
